var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1041",
    "data-name": "Rectangle 1041",
    width: 27,
    height: 27,
    transform: "translate(72.096 1191.866)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_889",
    "data-name": "Group 889",
    transform: "translate(-72.096 -1191.866)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4473",
    "data-name": "Path 4473",
    d: "M84.371,1207.742A3.371,3.371,0,1,0,81,1204.371,3.368,3.368,0,0,0,84.371,1207.742Z",
    transform: "translate(1.112 1.108)",
    fill: "none",
    stroke: "#1d3557",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4474",
    "data-name": "Path 4474",
    d: "M93.674,1208.73a1.855,1.855,0,0,0-.128,1.079,1.894,1.894,0,0,0,.5.966l.067.067a2.337,2.337,0,0,1,.488.73,2.242,2.242,0,0,1,0,1.719,2.337,2.337,0,0,1-.488.73,2.154,2.154,0,0,1-.729.483,2.149,2.149,0,0,1-1.721,0,2.154,2.154,0,0,1-.729-.483l-.067-.067a1.783,1.783,0,0,0-.966-.495,1.866,1.866,0,0,0-1.895.809,1.819,1.819,0,0,0-.308,1.011v.191a2.247,2.247,0,0,1-4.494,0v-.1a1.854,1.854,0,0,0-.346-1.034,1.821,1.821,0,0,0-.868-.663,1.869,1.869,0,0,0-1.079-.124,1.782,1.782,0,0,0-.966.494l-.067.067a2.152,2.152,0,0,1-.729.483,2.149,2.149,0,0,1-1.721,0,2.152,2.152,0,0,1-.729-.483,2.338,2.338,0,0,1-.488-.73,2.242,2.242,0,0,1,0-1.719,2.337,2.337,0,0,1,.488-.73l.067-.068a1.893,1.893,0,0,0,.5-.966,1.9,1.9,0,0,0-.808-1.9,1.912,1.912,0,0,0-1.016-.3h-.191a2.247,2.247,0,0,1,0-4.494h.1a1.814,1.814,0,0,0,1.035-.348,1.836,1.836,0,0,0,.661-.865,1.855,1.855,0,0,0,.128-1.079,1.893,1.893,0,0,0-.5-.966l-.067-.068a2.336,2.336,0,0,1-.488-.73,2.242,2.242,0,0,1,0-1.719,2.336,2.336,0,0,1,.488-.73,2.152,2.152,0,0,1,.729-.483,2.149,2.149,0,0,1,1.721,0,2.152,2.152,0,0,1,.729.483l.067.067a1.782,1.782,0,0,0,.966.494,1.87,1.87,0,0,0,1.079-.124h.09a1.876,1.876,0,0,0,.815-.686,1.819,1.819,0,0,0,.308-1.011v-.191a2.247,2.247,0,0,1,4.494,0v.1a1.82,1.82,0,0,0,.308,1.011,1.866,1.866,0,0,0,1.895.809,1.782,1.782,0,0,0,.966-.494l.067-.068a2.156,2.156,0,0,1,.729-.483,2.151,2.151,0,0,1,1.721,0,2.156,2.156,0,0,1,.729.483,2.338,2.338,0,0,1,.488.73,2.241,2.241,0,0,1,0,1.719,2.34,2.34,0,0,1-.488.73l-.067.067a1.893,1.893,0,0,0-.5.966,1.855,1.855,0,0,0,.128,1.079v.09a1.854,1.854,0,0,0,.68.82,1.91,1.91,0,0,0,1.016.3h.191a2.247,2.247,0,0,1,0,4.494h-.1a1.909,1.909,0,0,0-1.016.3A1.854,1.854,0,0,0,93.674,1208.73Z",
    transform: "translate(0.124 0.119)",
    fill: "none",
    stroke: "#1d3557",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.0c03afce27ff4343a2f69ba525208f52.svg";
export { ForwardRef as ReactComponent };